import { render, staticRenderFns } from "./UserTable.vue?vue&type=template&id=32d42992"
import script from "./UserTable.vue?vue&type=script&lang=ts"
export * from "./UserTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports